import { Column } from '../base-components/container.tsx';
import { OVERLAY_CLASS_NAME } from '../components/ui-constants.ts';
import { BoardCard } from './board-card.ts';
import { BoardLocalData } from './board-local-data.ts';

export type BoardCardMarksComponentProps = {
    localData: BoardLocalData;
    card: BoardCard;
};

export function BoardCardMarksComponent(props: BoardCardMarksComponentProps) {
    let { localData, card } = props;

    if (!card.marks.length) {
        return <></>;
    }

    let marks = card.marks.map(playerId => <div style={{
        pointerEvents: 'none',
        // color: localData.getPlayerColor(playerId),
        color: 'black',
        fontSize: '80px',
    }}>✗</div>);

    let isAttached = !!card.parentCard;

    return (
        <Column
            className={OVERLAY_CLASS_NAME}
            justifyContent='space-evenly'
            alignItems={isAttached ? 'end' : 'center'}
        >
            {marks}
        </Column>
    );
};